const isRequired = value =>
  !value || value.toString().trim() === '' ? 'Este é um campo obrigatório!' : undefined;

export default isRequired;
